import { render, staticRenderFns } from "./update-algo-data-details.html?vue&type=template&id=4871d925&scoped=true&external"
import script from "./update-algo-data-details.js?vue&type=script&lang=js&external"
export * from "./update-algo-data-details.js?vue&type=script&lang=js&external"
import style0 from "./update-algo-data-details.scss?vue&type=style&index=0&id=4871d925&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871d925",
  null
  
)

export default component.exports